// Product & content data for SSR CopperX
export const BRAND = {
  name: "SSR CopperX Trading LLC",
  short: "COPPERX",
  tagline: "Efficiency driven, Excellence delivered",
  positioning:
    "The Technical Authority for HVAC Copper Tubing & Refrigeration Piping Solutions in the GCC.",
  phone: "+971 50 746 8523",
  phoneHref: "+971507468523",
  email: "ssrcopperxtrading@gmail.com",
  address: "Dubai, United Arab Emirates",
  regions: ["Middle East", "Africa", "Asia"],
};

export const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Products", href: "#products" },
  { label: "Industries", href: "#industries" },
  { label: "Why CopperX", href: "#why" },
  { label: "Standards", href: "#standards" },
  { label: "Contact", href: "#contact" },
];

export const PRODUCTS = [
  {
    id: "pancake-coils",
    name: "Pancake Coils",
    subtitle: "Seamless ACR Copper • ASTM B280 / B743",
    image: "/brand/pancake-coil.jpg",    desc:
      "Seamless copper tubes engineered for air conditioning & refrigeration field service. Annealed for easy field installation; VRF-ready, compatible with R410A.",
    apps: ["VRV & VRF Systems", "HVAC Servicing", "Connecting Kits — Indoor/Outdoor", "Gas Piping"],
    specs: [
      {
        title: "Soft Coil — ASTM B280",
        cols: ["OD (mm)", "Wall (mm)", "Coil Weight (kg)"],
        rows: [
          ["6.35", "0.61", "5 — 15"],
          ["9.52", "0.71", "5 — 30"],
          ["12.70", "0.81", "10 — 45"],
          ["15.88", "1.02", "15 — 50"],
          ["19.05", "1.07", "20 — 60"],
          ["22.22", "1.14", "20 — 80"],
        ],
      },
      {
        title: "Coil Type — Economy (ASTM B743)",
        cols: ["OD (mm)", "Wall (mm)", "Coil Weight (kg)"],
        rows: [
          ["6.35", "0.50", "5 — 15"],
          ["9.52", "0.61", "5 — 30"],
          ["12.70", "0.71", "10 — 45"],
          ["15.88", "0.81", "15 — 50"],
          ["19.05", "0.89", "20 — 60"],
        ],
      },
      {
        title: "Coil Type — Lite Economy (ASTM B743)",
        cols: ["OD (mm)", "Wall (mm)", "Coil Weight (kg)"],
        rows: [
          ["6.35", "0.41", "5 — 15"],
          ["9.52", "0.50", "5 — 30"],
          ["12.70", "0.61", "10 — 45"],
          ["15.88", "0.71", "15 — 50"],
        ],
      },
    ],
  },
  {
    id: "lwc",
    name: "Level Wound Coil (LWC)",
    subtitle: "Plain & Inner-Grooved configurations",
    image: "/brand/lwc-coil.jpg",
    desc:
      "Precision level-wound coils for high-throughput OEM use — heat exchangers, AHUs, evaporator coils & capillary tube drawing. Available in plain bore and inner-grooved geometries.",
    apps: ["VRV & VRF", "AHUs", "Heat Exchangers", "Evaporator Coils", "Capillary Tube Drawing", "HVAC Industry"],
    specs: [
      {
        title: "LWC — Plain",
        cols: ["OD (mm)", "Wall Thickness (mm)", "Coil Weight (kg)"],
        rows: [
          ["5.00", "0.30", "60 — 120"],
          ["6.35", "0.30", "60 — 150"],
          ["7.00", "0.30", "80 — 180"],
          ["7.94", "0.35", "80 — 200"],
          ["9.52", "0.40", "100 — 220"],
          ["12.70", "0.50", "120 — 250"],
        ],
      },
      {
        title: "LWC — Inner Grooved",
        cols: ["OD (mm)", "I.D. (mm)", "Btm Wall (mm)", "Fin Depth (mm)", "Apex °", "Helix °", "No. of Teeth"],
        rows: [
          ["5.00", "4.30", "0.22", "0.15", "53", "18", "55"],
          ["6.35", "5.60", "0.25", "0.18", "53", "18", "60"],
          ["7.00", "6.20", "0.25", "0.18", "53", "18", "60"],
          ["7.94", "7.10", "0.28", "0.20", "53", "18", "65"],
          ["9.52", "8.60", "0.30", "0.20", "53", "18", "65"],
        ],
      },
    ],
  },
  {
    id: "straight-tube",
    name: "Straight Tube Series",
    subtitle: "Type K / L / M • OD 6 – 219 mm",
    image: "/brand/straight-tube.jpg",
    desc:
      "Hard-drawn copper straight lengths for chillers, medical gas piping, solar, plumbing, and general engineering. Available in standard 10 ft & 20 ft lengths.",
    apps: [
      "VRV & VRF",
      "Chillers",
      "Solar Equipment",
      "Medical Gas Piping",
      "Electrical Heaters",
      "Water / Gas / Oil Lines",
      "Plumbing",
      "General Engineering",
    ],
    specs: [
      {
        title: "Sizes Available",
        cols: ["Parameter", "Range"],
        rows: [
          ["Outer Diameter (OD)", "6 mm — 219 mm"],
          ["Wall Thickness", "0.33 mm — 9.39 mm"],
          ["Length", "10 ft / 20 ft (3.05 m / 6.10 m)"],
          ["Type", "K  |  L  |  M"],
          ["Standard", "ASTM B280 / B88 / B819"],
        ],
      },
    ],
  },
  {
    id: "aluminium-finstock",
    name: "Aluminium Finstock",
    subtitle: "Bare & Hydrophilic coated coils",
    image: "/brand/aluminium-finstock.jpg",
    desc:
      "Precision-rolled aluminium finstock for condensers, evaporators, and heat exchangers — supplied bare or with hydrophilic coating to enhance condensate drainage and corrosion resistance.",
    apps: ["HVAC-R", "Components", "Condensers", "Heat Exchangers"],
    specs: [
      {
        title: "Specification — Size Range",
        cols: ["Parameter", "Range / Options"],
        rows: [
          ["Alloy (AA)", "3102 / 1100 / 8011"],
          ["Temper", "O / H22 / H24 / H26"],
          ["Coating", "Bare / Hydrophilic Coated"],
          ["Thickness", "0.09 — 0.24 mm"],
          ["Width", "100 — 1220 mm"],
        ],
      },
    ],
  },
];

export const INDUSTRIES = [
  { name: "VRV & VRF Systems", icon: "Snowflake" },
  { name: "Chillers", icon: "Wind" },
  { name: "AHU & Air Handling", icon: "Fan" },
  { name: "Heat Exchangers", icon: "Flame" },
  { name: "Evaporator Coils", icon: "Thermometer" },
  { name: "Medical Gas Piping", icon: "HeartPulse" },
  { name: "Solar Thermal", icon: "Sun" },
  { name: "Plumbing & Sanitation", icon: "Droplets" },
  { name: "Fire Protection", icon: "ShieldAlert" },
  { name: "Gas Piping", icon: "Flame" },
  { name: "Refrigeration", icon: "Refrigerator" },
  { name: "General Engineering", icon: "Wrench" },
];

export const FEATURES = [
  {
    title: "Corrosion Resistant",
    desc: "Engineered for long-life service in humid GCC conditions and aggressive refrigerant environments.",
  },
  {
    title: "Cleaned Surfaces (ASTM)",
    desc: "Smooth, bright internal & external surfaces within ASTM B280 / B743 cleanness limits.",
  },
  {
    title: "High Dimensional Accuracy",
    desc: "Tight tolerances on OD, wall thickness, and concentricity — repeatable from coil to coil.",
  },
  {
    title: "Seamless Construction",
    desc: "Drawn-seamless tube with excellent welding & brazing performance for leak-free joints.",
  },
  {
    title: "VRF & R410A Ready",
    desc: "Suitable for Variable Refrigerant Flow systems and modern high-pressure refrigerants.",
  },
  {
    title: "Field-Test Verified",
    desc: "Elongation > 40% • Flaring expansion > 40% OD • Tensile strength > 205 MPa.",
  },
];
